import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { WidgetCard, WidgetCardProps } from './WidgetCard';
import { useDraggingContext } from '../../hooks';

const DraggableComponent = Draggable as any;

export interface DraggableItemData<T> {
  id: string;
  title?: string;
  type?: T;
  sensorId?: string;
  timestamp?: string;
  object?: any;
}

interface DraggableWidgetCardProps extends Omit<WidgetCardProps, 'title'> {
  item: DraggableItemData<any>;
  index: number;
  children?: React.ReactNode;
  error?: boolean;
  title?: string;
  enabled?: boolean;
  onEnabledChange?: (enabled: boolean) => void;
  timestamp?: string;
  hideArrowIcon?: boolean;
}

export const DraggableWidgetCard: React.FC<DraggableWidgetCardProps> = ({
  item,
  index,
  children,
  error,
  title,
  enabled,
  onEnabledChange,
  timestamp,
  hideArrowIcon,
  ...rest
}) => {
  const { isDragging, isDraggable } = useDraggingContext();

  return (
    <DraggableComponent
      key={item.id}
      draggableId={item.id}
      index={index}
      isDragDisabled={!isDraggable}>
      {(providedDraggable, snapshot) => (
        <div
          ref={providedDraggable.innerRef}
          {...providedDraggable.draggableProps}
          style={{
            userSelect: 'none',
            touchAction: 'none',
            transition: 'opacity 0.2s ease',
            opacity: snapshot.isDragging ? 1 : isDragging ? 0.5 : 1,

            ...providedDraggable.draggableProps.style,
            ...(snapshot.isDragging && {
              zIndex: 9999,
            }),
          }}>
          <WidgetCard
            title={
              title ? title.charAt(0).toUpperCase() + title.slice(1) : item.title ? item.title : ''
            }
            isDraggable={isDraggable}
            dragHandleProps={providedDraggable.dragHandleProps}
            error={error}
            enabled={enabled}
            onEnabledChange={onEnabledChange}
            timestamp={timestamp}
            hideArrowIcon={hideArrowIcon}
            {...rest}>
            {children}
          </WidgetCard>
        </div>
      )}
    </DraggableComponent>
  );
};
